import React from 'react';
import propTypes from 'prop-types';
import BankAccountForm from './BankAccountForm';
import { useSelector } from 'react-redux';
import EOCoverage from './EOCoverage';
import PersonalInformation from './PersonalInformation';
import SimpleContainer from 'tailwind-components/SimpleContainer/SimpleContainer';
import { USER_TYPES } from 'constants/enum';

export default function Main({
  editButtonRef,
  setModalText,
  setIsOpenPrimaryModal,
  setIsOpenSecondaryModal,
  refreshUser
}) {
  const user = useSelector(state => state.user.zohoData);
  const role = user.Position_at_Agency;
  const agencyId = user?.Account_Name?.id;

  const isAdmin = role === USER_TYPES.ADMIN && !!agencyId;

  return (
    <SimpleContainer className='gap-4'>
      <PersonalInformation
        setModalText={setModalText}
        setIsOpenPrimaryModal={setIsOpenPrimaryModal}
        refreshUser={refreshUser}
      />
      <div className='grid min-w-0 grid-cols-1 gap-4 lg:grid-cols-3'>
        <BankAccountForm
          editButtonRef={editButtonRef}
          setModalText={setModalText}
          setIsOpenPrimaryModal={setIsOpenPrimaryModal}
          setIsOpenSecondaryModal={setIsOpenSecondaryModal}
          isAdmin={isAdmin}
        />
        <EOCoverage
          setModalText={setModalText}
          setIsOpenPrimaryModal={setIsOpenPrimaryModal}
        />
      </div>
    </SimpleContainer>
  );
}

Main.propTypes = {
  editButtonRef: propTypes.object,
  setModalText: propTypes.func,
  setIsOpenPrimaryModal: propTypes.func,
  setIsOpenSecondaryModal: propTypes.func,
  refreshUser: propTypes.func
};
